import { render, staticRenderFns } from "./Oshaibao.vue?vue&type=template&id=6b458242&scoped=true"
import script from "./Oshaibao.vue?vue&type=script&lang=js"
export * from "./Oshaibao.vue?vue&type=script&lang=js"
import style0 from "./Oshaibao.vue?vue&type=style&index=0&id=6b458242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b458242",
  null
  
)

export default component.exports